import { defineComponent as _defineComponent } from 'vue'
import store, { config } from '@/store';
import { onMounted, ref } from 'vue';
import lastReadApi from '@/api/last-read';
import { lastReadType } from '@/type/last-read';
import manga from '@/components/manga.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose: __expose }) {
  __expose();

let lastReadList = ref<lastReadType[]>([]);


onMounted(async () => {
    lastReadList.value = await lastReadApi.get();
})

const __returned__ = { get lastReadList() { return lastReadList }, set lastReadList(v) { lastReadList = v }, get config() { return config }, manga }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})